'use client'

import { create } from 'zustand'

import { useSessionStore } from '@/features/veluvit/stores/session.store'

export type WatchedPayment = {
  ownerId: string
  orderId: string
  identity: number
  layerId?: string
}
type FlowState = {
  payments: WatchedPayment[]
  completed: { ownerId: string; orderId: string; layerId?: string } | null
  clearCompleted: (ownerId: string, orderId: string) => void
  complete: (ownerId: string, orderId: string, layerId?: string) => void
  gain: { orderId: string; ownerId: string; amount: number } | null
  watch: (ownerId: string, orderId: string, layerId?: string) => void
  remove: (ownerId: string, orderId: string) => void
  clearGain: (orderId: string) => void
  showGain: (ownerId: string, orderId: string, amount: number) => void
}

export const usePaymentFlowStore = create<FlowState>()((set) => ({
  payments: [],
  gain: null,
  completed: null,
  clearCompleted: (ownerId, orderId) =>
    set((state) =>
      state.completed?.ownerId === ownerId &&
      state.completed.orderId === orderId
        ? { completed: null }
        : state
    ),
  complete: (ownerId, orderId, layerId) =>
    set((state) =>
      state.completed?.ownerId === ownerId &&
      state.completed.orderId === orderId &&
      state.completed.layerId === layerId
        ? state
        : { completed: { ownerId, orderId, layerId } }
    ),
  watch: (ownerId, orderId, layerId) => {
    const session = useSessionStore.getState()
    if (session.data?.user?.id !== ownerId || session.data.user.guest) return
    set((state) =>
      state.payments.some(
        (item) =>
          item.ownerId === ownerId &&
          item.orderId === orderId &&
          item.identity === session.identity &&
          item.layerId === layerId
      )
        ? state
        : {
            payments: [
              ...state.payments.filter(
                (item) => item.ownerId !== ownerId || item.orderId !== orderId
              ),
              { ownerId, orderId, identity: session.identity, layerId },
            ],
          }
    )
  },
  remove: (ownerId, orderId) =>
    set((state) => ({
      payments: state.payments.filter(
        (item) => item.ownerId !== ownerId || item.orderId !== orderId
      ),
    })),
  clearGain: (orderId) =>
    set((state) => (state.gain?.orderId === orderId ? { gain: null } : state)),
  showGain: (ownerId, orderId, amount) => {
    if (amount > 0 && Number.isSafeInteger(amount))
      set({ gain: { ownerId, orderId, amount } })
  },
}))
